import { CircularProgress } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import CenteredState from './CenteredState';

const SPINNER_SIZE = 24;

function LoadingState() {
  const { translate } = useTranslation();

  return (
    <CenteredState role="status" testId="global-search-loading">
      <CircularProgress
        size={SPINNER_SIZE}
        aria-label={translate(LangEnum.GLOBAL_LOADING)}
        sx={{ color: 'text.secondary' }}
      />
    </CenteredState>
  );
}

export default LoadingState;
